module.exports = __webpack_public_path__ + "static/media/map.a2301c87.png";